import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const focus = "focus-visible:ring-2 focus-visible:ring-brand-700/30 focus-visible:ring-offset-2 focus-visible:outline-none";

const HeaderNew = ({ items, headerlogo }) => {
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isActive = (item) => {
    if (!item) return false;
    const slug = item.slug || item.ref_link_href || "";
    if (slug === "/" || slug === "") return location.pathname === "/";
    const clean = slug.replace(/^\//, "").split("#")[0];
    return location.pathname === `/${clean}`;
  };

  const getTo = (item) => {
    if (item.ref_link_href?.includes("#")) {
      return { pathname: "/", hash: item.ref_link_href };
    }
    const slug = item.ref_link_href || item.slug || "/";
    return slug.startsWith("/") ? slug : `/${slug}`;
  };

  return (
    <header
      className={`
        fixed top-0 left-0 right-0 z-50 transition-all duration-base ease-ds-std
        ${scrolled
          ? "bg-white/80 shadow-ds-sm border-b border-neutral-100"
          : "bg-white/40 border-b border-white/20"
        }
        backdrop-blur-md
      `}
    >
      <div className="max-w-[1400px] mx-auto flex items-center justify-between px-6 md:px-10 lg:px-20 py-4">
        {/* Logo */}
        <Link to="/" className={`flex items-center gap-2 no-underline rounded-sm ${focus}`}>
          {headerlogo ? (
            <img src={headerlogo} alt="OrthoPed" className="h-10" />
          ) : (
            <div className="flex items-center gap-1.5">
              <span className="material-symbols-outlined text-3xl font-bold text-brand-700">
                orthopedics
              </span>
              <span className="font-display text-xl font-bold tracking-tight">
                <span className="text-brand-700">Ortho</span>
                <span className="text-brand-500">Ped</span>
              </span>
            </div>
          )}
        </Link>

        {/* Desktop nav */}
        <nav className="hidden lg:flex items-center gap-8">
          {Array.isArray(items) &&
            items.map((item) => (
              <Link
                key={item._key}
                to={getTo(item)}
                target={item._type !== "linkInternal" ? "_blank" : undefined}
                className={`
                  text-sm font-medium no-underline transition-colors duration-base rounded-sm ${focus}
                  ${isActive(item)
                    ? "text-brand-700 font-semibold"
                    : "text-neutral-600 hover:text-brand-700"
                  }
                `}
              >
                {item.title}
              </Link>
            ))}
        </nav>

        {/* Mobile hamburger — visible below lg only */}
        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-ds-md hover:bg-neutral-100 transition-colors ${focus}`}
          aria-label="Toggle menu"
        >
          <span className="material-symbols-outlined text-2xl text-neutral-700">
            {mobileOpen ? "close" : "menu"}
          </span>
        </button>
      </div>

      {/* Mobile dropdown */}
      {mobileOpen && (
        <div className="lg:hidden bg-white/95 backdrop-blur-xl border-t border-neutral-100 px-6 py-6">
          <nav className="flex flex-col gap-4">
            {Array.isArray(items) &&
              items.map((item) => (
                <Link
                  key={item._key}
                  to={getTo(item)}
                  target={item._type !== "linkInternal" ? "_blank" : undefined}
                  className={`
                    text-base font-medium no-underline py-2 transition-colors rounded-sm ${focus}
                    ${isActive(item) ? "text-brand-700 font-semibold" : "text-neutral-700 hover:text-brand-700"}
                  `}
                >
                  {item.title}
                </Link>
              ))}
          </nav>
        </div>
      )}
    </header>
  );
};

export default HeaderNew;
